module.exports = new __parcel__URL__("offsite.249b9488.svg").toString();